import type { ParsedUrlQuery } from "node:querystring";
import { SearchQueryParams } from "src/components/pages/search/search.types";

export const getNormalizedUrlParams = (params: URLSearchParams) => {
    const urlParams = new URLSearchParams();
    params.forEach((value, key) => urlParams.append(key.toLowerCase(), value));

    return urlParams;
};

type EnumSearchQueryParamsKey = keyof typeof SearchQueryParams;

const getEnumKey = (paramsKey: string): EnumSearchQueryParamsKey | undefined => {
    const enumKeys = Object.keys(SearchQueryParams) as EnumSearchQueryParamsKey[];
    return enumKeys.find(key => SearchQueryParams[key].toLowerCase() === paramsKey.toLowerCase());
};

export const getCanonicalUrlParams = (params: URLSearchParams) => {
    const urlParams = new URLSearchParams();
    params.forEach((value, paramsKey) => {
        const enumKey = getEnumKey(paramsKey);
        if (enumKey) {
            urlParams.append(SearchQueryParams[enumKey], value);
        } else {
            urlParams.append(paramsKey, value);
        }
    });

    return urlParams;
};

export const getNormalizedRouterQuery = (query: ParsedUrlQuery) =>
    Object.keys(query).reduce((acc, key) => {
        const paramKey = getEnumKey(key);
        acc[paramKey ? SearchQueryParams[paramKey] : key] = query[key];
        return acc;
    }, {} as ParsedUrlQuery);

export const parseUrlQueryToUrlSearchParams = (query: ParsedUrlQuery): URLSearchParams => {
    const searchParams = new URLSearchParams();

    for (const key in query) {
        searchParams.append(key, query[key] as string);
    }

    return searchParams;
};

export const urlSearchParamsToQueryString = (urlSearchParams: URLSearchParams) => {
    const encodedQueryString = urlSearchParams.toString();
    return decodeURIComponent(encodedQueryString);
};

export const removeRedundantCommas = (queryString: string) => {
    return queryString.replace(/^,|,$|(?<=,),/g, "");
};
